import { PUBLIC_API_BASE_URL } from './serviceUrls';
export const PUBLIC_BLOG_API_BASE_URL = PUBLIC_API_BASE_URL;

export const BLOG_CATEGORY_LABELS = {
  'ideas-tips-tricks': 'Ideas, Tips, and Tricks',
  reviews: 'Reviews',
  news: 'News',
  tidbits: 'Tidbits',
};

export function blogApiUrl(pathname) {
  return `${String(PUBLIC_BLOG_API_BASE_URL).replace(/\/$/, '')}${pathname}`;
}

export function getBlogCategoryLabel(category) {
  return BLOG_CATEGORY_LABELS[category] || category || 'Post';
}

function toQueryString(params) {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    search.set(key, String(value));
  });
  const out = search.toString();
  return out ? `?${out}` : '';
}

export async function fetchBlogPosts(params = {}, { signal } = {}) {
  const response = await fetch(blogApiUrl(`/blog/posts${toQueryString(params)}`), {
    headers: { Accept: 'application/json' },
    signal,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || 'Failed to load blog posts');
  }
  return Array.isArray(data.posts) ? data.posts : [];
}

export async function fetchBlogPost(slug, { signal } = {}) {
  // The article's request may already be under way from app start (lib/earlyData.js).
  const { takeEarlyResponse } = await import('./earlyData');
  const response = await takeEarlyResponse(blogApiUrl(`/blog/posts/${encodeURIComponent(slug)}`), {
    headers: { Accept: 'application/json' },
    signal,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || 'Failed to load blog post');
  }
  if (!data.post) {
    throw new Error('Blog post not found');
  }
  return data.post;
}

export function formatBlogDate(input) {
  const timestampMs =
    typeof input === 'number' && Number.isFinite(input)
      ? (input < 10_000_000_000 ? input * 1000 : input)
      : Date.parse(String(input || ''));

  if (!Number.isFinite(timestampMs)) return '';

  const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
  ];
  const date = new Date(timestampMs);

  // Australian style, no ordinal: "5 October 2026".
  return `${date.getDate()} ${monthNames[date.getMonth()]} ${date.getFullYear()}`;
}

export function getBlogPostDisplayDate(post) {
  return post?.publishedAt || post?.updatedAt || post?.createdAt || null;
}
